import { console } from './console';

// http://rossscrivener.co.uk/blog/javascript-get-domain-exclude-subdomain
export const extractedRootDomain = (() => {
  let i = 0;
  let domain = window.location.hostname;
  const splitDomain = domain.split('.');
  const tempCookie = `___${new Date().getTime()}`;

  while (i < splitDomain.length - 1 && document.cookie.indexOf(`${tempCookie}=${tempCookie}`) === -1) {
    domain = splitDomain.slice(-1 - ++i).join('.'); // eslint-disable-line no-plusplus
    document.cookie = `${tempCookie}=${tempCookie};domain=${domain};`;
  }
  document.cookie = `${tempCookie}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;domain=${domain};`;
  return domain;
})();

export function isValidCookieDomain(domain: string): boolean {
  if (!domain) return false;

  // Simplified domain format check without specific TLD restrictions
  const domainRegex = /^\.?[a-zA-Z0-9][-a-zA-Z0-9]*(\.[a-zA-Z0-9][-a-zA-Z0-9]*)+$/i;

  // Remove leading dot for comparison
  const cleanDomain = domain.replace(/^\./, '');

  // Check basic format and that current hostname is on this domain
  return (
    domainRegex.test(domain) &&
    (window.location.hostname === cleanDomain || window.location.hostname.endsWith(`.${cleanDomain}`))
  );
}

export const isSameSite = (url: string) => {
  if (!url) return false;

  try {
    const hostnameOfGivenUrl = new URL(url).hostname;
    const reversedDomain = extractedRootDomain.split('.').reverse();
    const reversedHostnameOfGivenUrl = hostnameOfGivenUrl.split('.').reverse();

    return reversedDomain.every((val, idx) => val === reversedHostnameOfGivenUrl[idx]);
  } catch (error) {
    console.warn(error);
    return false;
  }
};
